module.exports = __webpack_public_path__ + "img/connected.1b69fe86.svg";